import { monthCodeToOffset } from "@package/grid-utils";

import { useMemoModal, useModalDragConstraint } from "../../components/Modal";
import { TracePrecedents } from "../../components/TracePrecedents";
import { TracePrecedentsModalWrapper } from "../../components/TracePrecedents/ModalWrapper";
import type { GetContextMenuSection } from "./helpers";
import { getIcon } from "./icons";
import { useUserSubscriptionTier } from "../../../data/user";

export const useGetMenuItemsTracePrecedents = (): GetContextMenuSection => {
  const tracePrecedence = useTraceTracePrecedentsModal();
  const { disabledFeatures } = useUserSubscriptionTier();

  return (ctx) => {
    if (!ctx.hasFormula) return [];

    return [
      {
        name: "Trace Precedents",
        icon: getIcon("function"),
        disabled: disabledFeatures?.tracePrecedents,
        tooltip: disabledFeatures?.tracePrecedents
          ? "Please upgrade your subscription to access this feature"
          : undefined,
        action: () => {
          const product = ctx.productId;
          const row = ctx.rowId;
          if (!row || !product) return;
          const offset = monthCodeToOffset(row);
          if (typeof offset !== "number") return;
          const field = ctx.headerParams?.field ?? "value";
          tracePrecedence.open({ product, row: offset, field });
        },
      },
    ];
  };
};

export const useTraceTracePrecedentsModal = () => {
  const constraintRef = useModalDragConstraint();
  const modal = useMemoModal((p: { product: string; field: string; row: number }) => {
    return (
      <TracePrecedentsModalWrapper constrainRef={constraintRef} onClose={() => modal.close()}>
        <TracePrecedents {...p} />
      </TracePrecedentsModalWrapper>
    );
  });
  return modal;
};
